import {
  Landmark, Mountain, Sparkles, Utensils, PawPrint, Gem, Map, Users,
  SlidersHorizontal, Headphones, ShieldCheck, Heart, Compass, Star, Sun,
} from "lucide-react";

const MAP = {
  landmark: Landmark, mountain: Mountain, sparkles: Sparkles, utensils: Utensils,
  "paw-print": PawPrint, gem: Gem, map: Map, users: Users, sliders: SlidersHorizontal,
  headphones: Headphones, "shield-check": ShieldCheck, heart: Heart, compass: Compass,
  star: Star, sun: Sun,
};

export function DynIcon({ name, className }) {
  const Ic = MAP[name] || Sparkles;
  return <Ic className={className} strokeWidth={1.4} />;
}
